import React from "react"
// import { Link } from "gatsby"
import { graphql } from "gatsby"
import { BgImage } from "gbimage-bridge"
import ReactMarkdown from "react-markdown"
import { GatsbyImage } from "gatsby-plugin-image";
import TopMenu from "../components/TopMenu"
import BookDemo from "../components/BookDemo"
import Footer from "../components/Footer"
import Seo from "../components/Seo"
import Testimonial from "../components/testimonials/Testimonial"
import VideoButton from "../components/VideoButton"

export default function PageVideos({data}) {
  const page = data.strapiPageVideos;
  const { image, title, subtitle } = page.info;
  const overviewVideos = page.overviewVideos;
  const instructionalVideos = page.instructionalVideos;
  const bookDemo = page.bookDemo;

  return (
    <div className="">
    <Seo 
      title={(page.seo && page.seo.title) ? page.seo.title : page.title}
      description={(page.seo && page.seo.description) ? page.seo.description : undefined }
      />
        <BgImage image={image.childImageSharp.gatsbyImageData} className="gs-bg-parallax"></BgImage>
        <TopMenu />

        <div className="gs-page-hero gs-scanners-hero">
          <video className="gs-header-video" playsInline autoPlay muted loop>
            <source src={page.heroVideo.publicURL} type="video/mp4" />
          </video>

            <div className="gs-page-hero__in gs-sect__in gs-scanners-hero__in posr">
              <div className="gs-container gs-container--900">
                <header className="gs-page-header">
                  <h1 className="gs-page-header-title gs-header-msg--mark">{ title }</h1>
                  <div className="gs-products-item__hr"></div>
                  <h3 className="gs-page-header-subtitle fw300">{ subtitle }</h3>
                </header>
              </div>
            </div>
        </div>

        {/* <div className="gs-page-hero gs-scanners-hero">
        <BackgroundImage fluid={page.heroImage.childImageSharp.fluid} style={{"backgroundSize": "contain", "backgroundPosition": "center center", "backgroundColor": "#000000" }}>
            <div className="gs-page-hero__in gs-sect__in gs-scanners-hero__in">
              <div className="gs-container gs-container--900">
                <header className="gs-page-header">
                  <h1 className="gs-page-header-title gs-header-msg--mark">{ title }</h1>
                  <div className="gs-products-item__hr"></div>
                  <h3 className="gs-page-header-subtitle fw300">{ subtitle }</h3>
                </header>
              </div>
            </div>
          </BackgroundImage>
          </div> */}

        <section className="gs-solution gs-color-contrast gs-products-item gs-bg-1">
          <div className="gs-sect__in gs-container gs-container--900">
            <header className="mb4">
            <ReactMarkdown source={page.introText} escapeHtml={false}/>
            </header>       

            <div className="gs-videos-list-header mb2">
              <h2 className="gs-videos-list-title mb05">{overviewVideos.title}</h2>
              <div className="gs-products-item__hr"></div>
              {
                overviewVideos.description && <ReactMarkdown source={overviewVideos.description} className="mb2" escapeHtml={false}/>
              }
            </div>
                 
            <ul className="gs-videos-list df fww" style={{ "--sal-duration": "1s" }}>
            {
              overviewVideos.videos.map((video, i)=>{
                return (
                  <li key={video.id} className="gs-videos-list-item" data-sal="slide-up">
                      <VideoButton youtubeId={video.link} type="wrap" className="mb1">
                        <GatsbyImage image={video.image.childImageSharp.gatsbyImageData} alt="" />
                      </VideoButton>
                      <div className="fwb mb1">{video.title}</div>
                      <ReactMarkdown source={video.description} escapeHtml={false}/>
                  </li>
                );
              })
            }
            </ul>
            </div>
        </section>

        <section className="gs-section-angular gs-section-angular--2">
              <div className="gs-sect__in gs-container gs-container--900 ovh">
                <header className="gs-videos-list-header mb2">
                  <h2 className="gs-videos-list-title mb05">{instructionalVideos.title}</h2>
                  <div className="gs-products-item__hr"></div>
                  {
                    instructionalVideos.description && <ReactMarkdown source={instructionalVideos.description} className="mb2" escapeHtml={false}/>
                  }
                </header>
                    
                <ul className="gs-videos-list df fww" style={{ "--sal-duration": "1s" }}>
                {
                  instructionalVideos.videos.map((video, i)=>{
                    return (
                      // <li key={video.id} className="gs-videos-list-item" data-sal="slide-up">
                      //   <BackgroundImage  fluid={video.image.childImageSharp.fluid}>
                      //     <VideoButton youtubeId={video.link} type="wrap" className="gs-videos-list-item__img mb1">
                      //     </VideoButton>
                      //   </BackgroundImage>
                      //   <div className="fwb mb1">{video.title}</div>
                      //   <ReactMarkdown source={video.description} escapeHtml={false}/>
                      // </li>
                      <li key={video.id} className="gs-videos-list-item" data-sal="slide-up">
                        <VideoButton youtubeId={video.link} type="wrap" className="mb1">
                          <GatsbyImage image={video.image.childImageSharp.gatsbyImageData} alt="" />
                        </VideoButton>
                        <div className="fwb mb1">{video.title}</div>
                        <ReactMarkdown source={video.description} escapeHtml={false}/>
                      </li>
                    );
                  })
                }
                </ul>
                
              </div>
            </section>

            {/* <article className="gs-products-item">
                  <BookDemo></BookDemo>
            </article> */}

        <section className="gs-products">
          <div className="gs-bg-parallax__wrap">
            <BookDemo
              title={bookDemo.title}
              text={bookDemo.text}
              cta={bookDemo.buttonText}
            ></BookDemo>
            <article className="gs-products-item gs-products-item--last">
              <div className="gs-sect__in gs-container ovh">
                <Testimonial className="clean mb2"></Testimonial>
              </div>
            </article>
            <Footer/>
          </div>
        </section>
      </div>
  );
}

export const query = graphql`
  {
    strapiPageVideos {
      id
      seo {
        title
        description
      }
      info {
        title
        subtitle
        slug
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
      introText
      heroImage {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      heroVideo {
        publicURL
      }
      overviewVideos {
        title
        description
        videos {
          id
          title
          image {
            childImageSharp {
              gatsbyImageData(
                width: 600
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
          description
          link
        }
      }
      instructionalVideos {
        title
        description
        videos {
          id
          title
          image {
            childImageSharp {
              gatsbyImageData(
                width: 600
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
          description
          link
        }
      }
      bookDemo {
        title
        text
        buttonText
      }
    }
  }
`